const format = number => new Intl.NumberFormat().format(number)

const updateData = ({ data2paste, data }) => {
    data.forEach(instrument => {
        instrument.color = false
    })

    data2paste.forEach(quote => {
        const instrument = data.find(i => i.code === quote.s)

        if (instrument !== undefined) {
            instrument.color =
                instrument.price > quote.r
                    ? 'red'
                    : instrument.price < quote.r
                    ? 'green'
                    : false
            instrument.price = quote.r
            instrument.percentChange = (
                (quote.r * 100) / instrument.close -
                100
            ).toFixed(2)
        }
    })
}

const prepareLastItems = lastItemsObject => {
    const list = []

    lastItemsObject.priceRecords.forEach(el => {
        el.type = 'priceRecord'
        el.timestamp = Date.parse(el.time)
        list.push(el)
    })
    lastItemsObject.volatilityPeriods.forEach(el => {
        el.type = 'volatilityPeriod'
        el.timestamp = Date.parse(el.beginTime)
        list.push(el)
    })

    list.sort((a, b) => a.timestamp - b.timestamp)

    return list
}

const getHoursCount = timeString =>
    Math.floor(
        (new Date().getTime() - Date.parse(timeString + '.000Z')) /
            (1000 * 60 * 60)
    )

const getHoursAgo = ({ time, strings }) => {
    const count = getHoursCount(time)

    return strings.ago.replace('{COUNT}', count || '<1')
}

const getHoursLast = ({ time, strings }) => {
    const count = getHoursCount(time)

    return strings.last.replace('{COUNT}', count || '<1')
}

const toISOString = n => new Date(n).toISOString().split('.')[0]

export default {
    format,
    toISOString,
    updateData,
    prepareLastItems,
    getHoursAgo,
    getHoursLast
}

// Array.prototype.find() polyfill
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            if (this == null)
                throw new TypeError('"this" is null or not defined')

            var o = Object(this)
            var len = o.length >>> 0

            if (typeof predicate !== 'function')
                throw new TypeError('predicate must be a function')

            var thisArg = arguments[1]
            var k = 0

            while (k < len) {
                var kValue = o[k]
                if (predicate.call(thisArg, kValue, k, o)) return kValue
                k++
            }

            return undefined
        },
        configurable: true,
        writable: true
    })
}

// Element.closest() polyfill
;(function (ELEMENT) {
    ELEMENT.matches =
        ELEMENT.matches ||
        ELEMENT.mozMatchesSelector ||
        ELEMENT.msMatchesSelector ||
        ELEMENT.oMatchesSelector ||
        ELEMENT.webkitMatchesSelector
    ELEMENT.closest =
        ELEMENT.closest ||
        function closest(selector) {
            if (!this) return null
            if (this.matches(selector)) return this
            if (!this.parentElement) return null
            else return this.parentElement.closest(selector)
        }
})(Element.prototype)
